import styled from 'styled-components';
import Button from '@components/Button';

export const CancelButton = styled(Button)`
  button.MuiButtonBase-root {
    display: flex;
    margin-left: 20px;
    width: 18rem;
    height: 3rem;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }
`;

export const ListDateStyle = styled.p``;

export const IntegrationButton = styled(Button)`
  button.MuiButton-outlined {
    border-radius: 8px;
  }
`;

export const ManualIntegrationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  border-bottom: 0.063rem solid ${({ theme }) => theme.background_secondary};
  padding-bottom: 1rem;
`;
